import { useActivity } from 'modules/core/lib/activities/activity'
import { ActivityComponent } from 'modules/core/lib/activities/types'

import { DefaultComplianceSettingsCreateModal } from './DefaultComplianceSettingsCreateModal'

type DefaultComplianceSettingsCreateActivityProps = {
  refetchQuery: string
}

export const DefaultComplianceSettingsCreateActivity: ActivityComponent<
  DefaultComplianceSettingsCreateActivityProps
> = (data) => {
  const { open, closeActivity } = useActivity()

  return (
    <DefaultComplianceSettingsCreateModal
      isOpen={open}
      onClose={closeActivity}
      refetchQuery={data.refetchQuery}
    />
  )
}
